import { render, staticRenderFns } from "./traMediciPharmacy.vue?vue&type=template&id=44306322&scoped=true"
import script from "./traMediciPharmacy.vue?vue&type=script&lang=js"
export * from "./traMediciPharmacy.vue?vue&type=script&lang=js"
import style0 from "./traMediciPharmacy.vue?vue&type=style&index=0&id=44306322&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44306322",
  null
  
)

export default component.exports